var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import Fade from '@mui/material/Fade';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { SubMenu, MenuItem, IconWrap, MenuWrapper, SubMenuItem, MenuItemLeft, MenuItemRight, MenuContainer, SideBarToggle, MenuItemHeader, SubMenuItemLeft, SideBarFooterBox, SideBarToggleBox, SubMenuItemHeader, MediaContentImage, MediaClosedWrapper, MenuContainerFooter, MenuContainerContent, CustomSideNavBarTooltip, OrganizationMenuContainer, OrganizationDetailViewImage, OrganizationDetailViewInfoContainer, OrganizationDetailViewImageContainer, OrganizationDetailViewInnerContainer, Icon, SearchBarContainer, StyledSearchIcon, StyledSearchInput, } from './styles';
import DefaultOrgIcon from '../../../images/default_org_img.png';
import DefaultSuperAdminIcon from '../../../images/default_super_admin_img.png';
import { makeSelectRoot, makeSelectRecentlySelectedOrgs, selectSearchString, makeSelectOrganizations, makeSelectOrgInitialized, } from '../selectors';
import * as rootActions from '../../Root/actions';
import { useLocalStorage } from '../../../utils/hooks/services';
import { Button } from '@appspotr/ui-kit';
import storageService from '../../../utils/storageService';
import { useLocation } from 'react-router-dom';
import { truncate } from '../../../utils';
import { PermissionsWrapper } from '@project/components/PermissionsWrapper';
export var PREV_SELECTED_ORGANIZATION_LIST_OBJECT = 'PREV_SELECTED_ORGANIZATION_LIST_OBJECT';
export var MAX_FONT_SIZE = 22;
export var MIN_FONT_SIZE = 14;
export var DEFAULT_SIZE_LIMIT = 25;
var MainSideBar = function (_a) {
    var role = _a.role, secondaryMenuItems = _a.secondaryMenuItems, secondaryMenuType = _a.secondaryMenuType, setMainSideBarState = _a.setMainSideBarState, setSelectedOrganizationId = _a.setSelectedOrganizationId, setSearchString = _a.setSearchString;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(false), isOrgDropDownOpen = _c[0], setIsOrgDropDownOpen = _c[1];
    var _d = useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = useState(null), currentSubmenuElement = _e[0], setCurrentSubMenuElement = _e[1];
    var pathNameArray = pathname === null || pathname === void 0 ? void 0 : pathname.split('/');
    var organizationId = pathNameArray[1] === 'organizations' && pathNameArray[2] !== 'new'
        ? pathNameArray[2]
        : undefined;
    var storageServiceOrganizationId = storageService.getItem('selectedOrganizationId');
    var _f = useSelector(makeSelectRoot()) || {}, _g = _f.me, me = _g === void 0 ? {} : _g, _h = _f.selectedOrganizationId, selectedOrganizationId = _h === void 0 ? '' : _h;
    var recentlySelectedOrgs = useSelector(makeSelectRecentlySelectedOrgs(selectedOrganizationId));
    var allOrganizations = useSelector(makeSelectOrganizations());
    var isOrgInitialized = useSelector(makeSelectOrgInitialized());
    var selectedOrganization = !organizationId || organizationId === 'shared'
        ? undefined
        : allOrganizations === null || allOrganizations === void 0 ? void 0 : allOrganizations.find(function (org) { return org.id === organizationId; });
    var searchString = useSelector(selectSearchString);
    var sideBarState = useLocalStorage('sidebar_open');
    useEffect(function () {
        if (sideBarState.getValue()) {
            setIsOpen(true);
            setMainSideBarState(true);
        }
        else {
            setIsOpen(false);
            setMainSideBarState(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setMainSideBarState]);
    useEffect(function () {
        organizationId &&
            ((selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id) || organizationId === 'shared') &&
            organizationId !== storageServiceOrganizationId &&
            setSelectedOrganizationId(organizationId, me.id);
        /*=============================if org Id not valid, redirct to invalid-org page ===========================*/
        if (organizationId /*if not other pages like user page */ &&
            isOrgInitialized &&
            !(selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id) /*orgId is not valid */ &&
            organizationId !== 'shared') {
            navigate("/invalid-org");
        }
        /*=============================!if org Id not valid, redirct to invalid-org page ===========================*/
    }, [
        organizationId,
        storageServiceOrganizationId,
        me.id,
        setSelectedOrganizationId,
        selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id,
        dispatch,
        isOrgInitialized,
        navigate,
    ]);
    var subMenuRightArrow = function (index) {
        if (currentSubmenuElement !== index) {
            return (_jsx(IconWrap, __assign({ open: isOpen }, { children: _jsx(FontAwesomeIcon, { icon: faChevronDown, style: isOpen ? { width: 12, height: 11 } : { width: 7, height: 8 }, color: "#ffffff", fixedWidth: true }) })));
        }
        return (_jsx(IconWrap, __assign({ open: isOpen }, { children: _jsx(FontAwesomeIcon, { icon: faChevronUp, style: isOpen ? { width: 12, height: 11 } : { width: 7, height: 8 }, color: "#ffffff", fixedWidth: true }) })));
    };
    var toggleSubMenu = function (index) {
        if (currentSubmenuElement === null || currentSubmenuElement !== index) {
            setIsExpanded(true);
            setCurrentSubMenuElement(index);
        }
        else {
            setIsExpanded(false);
            setCurrentSubMenuElement(null);
        }
    };
    var subItemInTheParent = function (item) {
        var result = item.children.find(function (path) { return path.isActive == true; });
        return typeof result != 'undefined';
    };
    var getFontSize = function (organizationName) {
        var _a;
        var strLength = (_a = organizationName === null || organizationName === void 0 ? void 0 : organizationName.length) !== null && _a !== void 0 ? _a : 0;
        var fontSize = MAX_FONT_SIZE;
        if (strLength >= DEFAULT_SIZE_LIMIT)
            fontSize -= strLength - DEFAULT_SIZE_LIMIT;
        if (fontSize > MAX_FONT_SIZE)
            fontSize = MAX_FONT_SIZE;
        if (fontSize < MIN_FONT_SIZE)
            fontSize = MIN_FONT_SIZE;
        return fontSize;
    };
    var OrganizationDetailView = function (organizationId) {
        var _a;
        return (_jsxs(_Fragment, { children: [_jsx(OrganizationDetailViewImageContainer, __assign({ open: isOpen }, { children: _jsx(OrganizationDetailViewImage, { open: isOpen, src: ((_a = selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.meta) === null || _a === void 0 ? void 0 : _a.logo) || DefaultOrgIcon }) })), _jsx(OrganizationDetailViewInfoContainer, { children: _jsx(OrganizationDetailViewInnerContainer, __assign({ open: isOpen, fontSize: getFontSize(organizationId) }, { children: organizationId })) }), _jsx("button", { children: isOrgDropDownOpen ? (_jsx(Icon, { className: "fas fa-caret-up", color: "#fff" })) : (_jsx(Icon, { className: "fas fa-caret-down", color: "#fff" })) })] }));
    };
    var OrganizationListView = function () {
        return (_jsxs(_Fragment, { children: [recentlySelectedOrgs.map(function (item) {
                    if (item === void 0) { item = {}; }
                    return (_jsx(CustomSideNavBarTooltip, __assign({ title: item.name, placement: "right", arrow: true, disableFocusListener: true, disableTouchListener: true, TransitionComponent: Fade, disableHoverListener: item.name.length < DEFAULT_SIZE_LIMIT }, { children: _jsx(SubMenuItem, __assign({ organizationList: true, onClick: function () {
                                setSelectedOrganizationId(item.id, me.id);
                                navigate("/organizations/".concat(item.id, "/apps"));
                            } }, { children: _jsx(SubMenuItemHeader, __assign({ open: true }, { children: truncate(item.name || '...', DEFAULT_SIZE_LIMIT) })) })) }), item.id));
                }), _jsx(SubMenuItem, __assign({ organizationList: true, onClick: function () {
                        navigate("/organizations");
                    } }, { children: _jsx(SubMenuItemHeader, __assign({ open: isOpen }, { children: "More..." })) }))] }));
    };
    var organizationMenu = function () {
        if (isOpen) {
            return (_jsx(OrganizationMenuContainer, __assign({ onClick: function () { return setIsOrgDropDownOpen(!isOrgDropDownOpen); } }, { children: OrganizationDetailView(role === null || role === void 0 ? void 0 : role.selectedOrganizationId) })));
        }
        else {
            return (_jsx(MediaClosedWrapper, { children: _jsx(MediaContentImage, { closedImage: true, src: DefaultOrgIcon }) }));
        }
    };
    var superAdminMenuTop = function () {
        if (isOpen) {
            return (_jsxs(OrganizationMenuContainer, { children: [_jsx(OrganizationDetailViewImageContainer, __assign({ open: isOpen }, { children: _jsx(OrganizationDetailViewImage, { open: isOpen, src: DefaultSuperAdminIcon }) })), _jsx(OrganizationDetailViewInfoContainer, { children: _jsx(OrganizationDetailViewInnerContainer, __assign({ open: isOpen }, { children: "Super Admin" })) })] }));
        }
        else {
            return (_jsx(MediaClosedWrapper, { children: _jsx(MediaContentImage, { closedImage: true, src: DefaultSuperAdminIcon }) }));
        }
    };
    var menuItemList = function (item, index) {
        if (item.children != null) {
            return (_jsx(PermissionsWrapper, __assign({ hideOnDisable: true, multiTargets: __spreadArray(['partner:123:organizations'], (item.target || []), true), action: "read" }, { children: _jsxs(MenuWrapper, { children: [_jsxs(MenuItem, __assign({ active: currentSubmenuElement === null && subItemInTheParent(item), expanded: isExpanded && currentSubmenuElement === index, onClick: function () {
                                toggleSubMenu(index);
                            } }, { children: [_jsx(MenuItemLeft, __assign({ manuParent: true, open: isOpen }, { children: item.icon })), _jsx(MenuItemHeader, __assign({ open: isOpen }, { children: item.header })), _jsx(MenuItemRight, __assign({ open: isOpen }, { children: subMenuRightArrow(index) }))] })), isExpanded &&
                            currentSubmenuElement === index &&
                            subMenuItemList(item)] }, index) }), item.label));
        }
        return (_jsx(PermissionsWrapper, __assign({ hideOnDisable: true, multiTargets: __spreadArray(['partner:123:organizations'], (item.target || []), true), action: "read" }, { children: _jsxs(MenuItem, __assign({ open: isOpen, active: item.isActive, onClick: function () { return item.onClick && item.onClick(item); } }, { children: [_jsx(MenuItemLeft, { children: item.icon }), _jsx(MenuItemHeader, __assign({ open: isOpen }, { children: item.header }))] })) }), item.label));
    };
    var subMenuItemList = function (item) {
        return (_jsx(SubMenu, { children: item.children.map(function (subMenuItem) {
                return (_jsx(PermissionsWrapper, __assign({ hideOnDisable: true, multiTargets: __spreadArray([
                        'partner:123:organizations'
                    ], (subMenuItem.target || []), true), action: "read" }, { children: _jsxs(SubMenuItem, __assign({ onClick: function () {
                            subMenuItem.onClick(subMenuItem);
                        }, open: isOpen, active: subMenuItem.isActive }, { children: [_jsx(SubMenuItemLeft, { children: subMenuItem.icon }), _jsx(SubMenuItemHeader, __assign({ open: isOpen }, { children: subMenuItem.label }))] })) }), subMenuItem.label));
            }) }));
    };
    var sideBarToggle = function () {
        setIsOpen(!isOpen);
        if (!isOpen) {
            sideBarState.setValue('true');
        }
        else {
            sideBarState.removeValue();
        }
    };
    var sideBarFooter = function () {
        return (_jsx(SideBarFooterBox, { children: _jsx(SideBarToggle, { children: _jsx(SideBarToggleBox, __assign({ onClick: function () { return sideBarToggle(); } }, { children: _jsx(FontAwesomeIcon, { icon: isOpen ? faChevronLeft : faChevronRight, style: isOpen ? { width: 12, height: 11 } : { width: 7, height: 8 }, color: "#ffffff", fixedWidth: true }) })) }) }));
    };
    return (_jsxs(MenuContainer, __assign({ open: isOpen }, { children: [_jsxs(MenuContainerContent, { children: [secondaryMenuType != 'partner'
                        ? organizationMenu()
                        : superAdminMenuTop(), organizationId && isOrgDropDownOpen && isOpen ? (_jsxs(SearchBarContainer, { children: [_jsx(StyledSearchIcon, { icon: faSearch }), _jsx(StyledSearchInput, { type: "text", placeholder: "Search", value: searchString, onChange: function (event) { return setSearchString(event.target.value); } })] })) : null, organizationId && isOrgDropDownOpen && isOpen
                        ? OrganizationListView()
                        : null, organizationId && isOrgDropDownOpen && isOpen && (_jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: ['partner:123:organizations'], hideOnDisable: true }, { children: _jsx(Button, __assign({ iconLeft: faPlus, onClick: function () {
                                navigate("/organizations/new");
                            }, style: {
                                backgroundColor: '#96A7C7',
                                width: '240px',
                                justifyContent: 'center',
                                margin: '16px',
                                border: '0px',
                            }, type: "primary" }, { children: "New Organization" })) }))), secondaryMenuItems &&
                        ((selectedOrganizationId && selectedOrganizationId !== 'shared') ||
                            secondaryMenuType === 'partner') &&
                        secondaryMenuItems.map(function (item, index) {
                            return (((selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.type) !== 'managed' ||
                                item.label !== 'Billing') &&
                                menuItemList(item, index));
                        })] }), _jsx(MenuContainerFooter, { children: sideBarFooter() })] })));
};
var mapDispatchToProps = function (dispatch) { return ({
    setMainSideBarState: function (state) {
        return dispatch(rootActions.setMainSidebarState(state));
    },
    setSelectedOrganizationId: function (orgId, userId) {
        dispatch(rootActions.selectOrganization(orgId, userId));
        dispatch(rootActions.loadApps());
    },
    setSearchString: function (searchString) {
        dispatch(rootActions.setSearchString(searchString));
    },
}); };
var withConnect = connect(null, mapDispatchToProps);
export default compose(withConnect)(MainSideBar);
